"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientRecallInfo_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PatientRecallInfo_Factory = /** @class */ (function () {
    function PatientRecallInfo_Factory() {
    }
    PatientRecallInfo_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            LastRecallDate: Date_Factory_1.Date_Factory.CreateIncoming(model.LastRecallDate, { ignoreTimePortion: true }),
            NextRecallDue: Date_Factory_1.Date_Factory.CreateIncoming(model.NextRecallDue, { ignoreTimePortion: true }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    PatientRecallInfo_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            LastRecallDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.LastRecallDate, { ignoreTimePortion: true }),
            NextRecallDue: Date_Factory_1.Date_Factory.CreateOutgoing(model.NextRecallDue, { ignoreTimePortion: true }),
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return PatientRecallInfo_Factory;
}());
exports.PatientRecallInfo_Factory = PatientRecallInfo_Factory;
